import {
  Grid,
  Paper,
  Box,
  TextField,
  Toolbar,
  Typography,
  Divider,
  useMediaQuery,
  List,
  ListItemButton,
  Stack,
  Tooltip,
  useTheme,
  Avatar,
  Checkbox,
  Snackbar,
  Button,
  Alert,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Skeleton,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import LoadingListSkeleton from "../loadingSkeletons/LoadingList";
import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import DriveFileMoveOutlinedIcon from "@mui/icons-material/DriveFileMoveOutlined";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../user-redux/selector";
import { appSelector } from "../redux/selector";
import {
  getInActiveCandidatesAction,
  getActiveCandidatesAction,
  updateCandidateStatusAction,
  selectedCandidateAction,
} from "../redux/action";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router";
import Noimag from "../images/Nocandidate.png"
import Key from "../../clientVariables.json";

const Inactivecandidates = ({
  ViewHandler,
  candidatesRefresh,
  candidates,
  setDateFilter,
  handleHeader,
}) => {
  const dispatch = useDispatch();
  const { inActiveCandidates, selectedCandidate } = useSelector(appSelector);
  //  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [hoverIndex, setHoverIndex] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  const [checkedCustomerData, setCheckedCustomerData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [inactiveReason, setInactiveReason] = useState(selectedCandidate?.inactive_reason);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [inActiveCandidate, setInActiveCandidate] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [currentSelectedId, setCurrentSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  const handleIconClick = () => {
    setIsSearchActive(!isSearchActive);
    setSearchTerm("");
  };

  //console.log("inActiveCandidates", inActiveCandidates);
  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const isMobileSmall = useMediaQuery("(max-width: 479px)");
  const isMobileLarge = useMediaQuery(
    "(min-width: 480px) and (max-width: 767px)"
  );
  const isTabletSmall = useMediaQuery(
    "(min-width: 768px) and (max-width: 991px)"
  );
  const isTabletLarge = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopXS = useMediaQuery(
    "(min-width: 992px) and (max-width: 1199px)"
  );
  const isDesktopSmall = useMediaQuery(
    "(min-width: 1200px) and (max-width: 1439px)"
  );
  const isDesktopMedium = useMediaQuery(
    "(min-width: 1440px) and (max-width: 1919px)"
  );
  const isDesktopLarge = useMediaQuery("(min-width: 1920px)");

  const { user } = useSelector(userSelector);
  const avatarColors = [
    "#C5CAE9",
    "#DCEDC8",
    "#FFECB3",
    "#F8BBD0",
    "#C8E6C9",
    "#FFD180",
    "#BBDEFB",
    "#FFCC80",
    "#E6EE9C",
    "#FFD180",
  ];

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const response = await dispatch(
          getInActiveCandidatesAction(user?.id, 1, 500)
        );
        if (response?.data?.candidates?.length > 0) {
          let firstCandidate = response?.data?.candidates?.[0];
          dispatch(selectedCandidateAction(firstCandidate));
          setCurrentSelectedId(firstCandidate.candidate_id); // Set initial selection
        } else {
          dispatch(selectedCandidateAction(null));
          setInActiveCandidate(true);
        }
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, []);


  const theme = useTheme();

  const handleCandidateClick = (candidate) => {
    dispatch(selectedCandidateAction(candidate));
    setCurrentSelectedId(candidate.candidate_id);
  };

  const handleListItemClick = (index, data) => {
    const isSelected = selectedItems.includes(data.candidate_id);

    if (isSelected) {
      const newSelected = selectedItems.filter(
        (selectedId) => selectedId !== data.candidate_id
      );

      const newCheckedCustomerData = checkedCustomerData.filter(
        (item) => item.candidate_id !== data.candidate_id
      );
      setSelectedItems(newSelected);
      setCheckedCustomerData(newCheckedCustomerData);
    } else {
      const newSelected = [...selectedItems, data.candidate_id];
      const newCheckedCustomerData = [...checkedCustomerData, data];
      setSelectedItems(newSelected);
      setCheckedCustomerData(newCheckedCustomerData);
    }
  };

  const updateStatus = async () => {
    if (selectedItems.length === 0) {
      return; // Exit early if no items selected
    }

    // Store the first reactivated candidate ID so ActiveCandidates can select it when switching back
    if (selectedItems.length > 0) {
      sessionStorage.setItem("target_candidate_id", String(selectedItems[0]));
    }

    const data = {
      candidateid: selectedItems,
      candidate_status: 1,
      inactive_reason: inactiveReason,
    };

    await dispatch(updateCandidateStatusAction(data, user?.id));

    const userId = user?.usertype === 13 ? user?.admin_id : user?.id;
    if (userId) {
      await dispatch(getActiveCandidatesAction(userId, 1, 500));
    }

    setSelectedItems([]);
    setCheckedCustomerData([]);
    setInactiveReason("");

    // Get updated list of inactive candidates
    const response = await dispatch(getInActiveCandidatesAction(user?.id, 1, 50));

    // Check if there are any remaining inactive candidates
    if (response?.data?.candidates?.length === 0 || filteredCandidates.length - selectedItems.length === 0) {
      // Clear the selected candidate and show the dialog
      dispatch(selectedCandidateAction(null));
      setInActiveCandidate(true);
    } else {
      // Find next candidate to select
      const remainingCandidates = response?.data?.candidates?.filter(
        candidate => !selectedItems.includes(candidate.candidate_id)
      );

      if (remainingCandidates && remainingCandidates.length > 0) {
        dispatch(selectedCandidateAction(remainingCandidates[0]));
        setCurrentSelectedId(remainingCandidates[0].candidate_id);
      } else {
        dispatch(selectedCandidateAction(null));
        setInActiveCandidate(true);
      }
    }

    setSnackbarOpen(true);
  };


  const colorMap = {
    A: "#C5CAE9",
    B: "#DCEDC8",
    C: "#FFECB3",
    D: "#FFCCBC",
    E: "#F8BBD0",
    F: "#D1C4E9",
    G: "#C8E6C9",
    H: "#FFF9C4",
    I: "#B3E0C8",
    J: "#FFD180",
    K: "#FFAB91",
    L: "#E1BEE7",
    M: "#BBDEFB",
    N: "#C8E6C9",
    O: "#FFCC80",
    P: "#F48FB1",
    Q: "#E6EE9C",
    R: "#B2DFDB",
    S: "#FFD180",
    T: "#FFCC80",
    U: "#F0F4C3",
    V: "#FFAB91",
    W: "#FFECB3",
    X: "#D1C4E9",
    Y: "#B2DFDB",
    Z: "#C5CAE9",
  };

  const getContrastingTextColor = (backgroundColor) => {
    const luminance =
      (0.299 * parseInt(backgroundColor.substr(1, 2), 16) +
        0.587 * parseInt(backgroundColor.substr(3, 2), 16) +
        0.114 * parseInt(backgroundColor.substr(5, 2), 16)) /
      255;
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  };

  const getLetters = (name) => {
    const splitStr = name.split(" ");
    if (splitStr.length > 1) {
      return `${splitStr[0][0].toUpperCase()}${splitStr[1][0].toUpperCase()}`;
    }
    return name[0].toUpperCase();
  };

  const stringAvatar = (name) => {
    const letterUpperCase = name[0].toUpperCase();
    const backgroundColor = colorMap[letterUpperCase] || "#2196F3";
    const textColor = getContrastingTextColor(backgroundColor);

    return {
      sx: {
        bgcolor: backgroundColor,
        color: textColor,
        fontSize: isDesktopLarge ? 14 : 10,
        height: isDesktopLarge ? "40px" : "28px",
        width: isDesktopLarge ? "40px" : "28px",
      },
      children: getLetters(name),
    };
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const filteredCandidates = inActiveCandidates
    .filter(
      (candidate, index, self) =>
        index ===
        self.findIndex((c) => c.candidate_id === candidate.candidate_id) // Remove duplicates
    )
    .filter((candidate) =>
      candidate.candidate_name
        .toLowerCase()
        .startsWith(searchTerm.toLowerCase())
    );
  useEffect(() => {
    if (filteredCandidates.length > 0 && !selectedCandidate) {
      handleCandidateClick(filteredCandidates[0]);
    }
  }, [filteredCandidates]);


  const handleCloseDialog = () => {
    setInActiveCandidate(false);
    // Clean up any selected states
    setSelectedItems([]);
    setCheckedCustomerData([]);
    setInactiveReason("");

    //console.log("User object in handleCloseDialog:", user);
    //console.log("User type in handleCloseDialog:", user?.usertype);

    // Navigate based on user type
    if (user?.usertype == 7) {
      navigate("/admin-dashboard", { replace: true });
    } else if (user?.usertype == 13) {
      navigate("/admin-dashboard");
    } else {
      navigate("/", { replace: true });
    }
  };

  useEffect(() => {
    const img = new Image();
    img.src = Noimag;
    img.onload = () => setImageLoaded(true);
  }, []);


  const showPanels = loading || filteredCandidates.length > 0 || inActiveCandidates?.length > 0;

  const renderProfileContentSkeleton = () => (
    <Box sx={{ p: 2 }}>
      <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
      <Skeleton variant="text" width="55%" height={22} sx={{ mb: 1 }} />
      <Skeleton variant="text" width="45%" height={22} sx={{ mb: 2 }} />
      <Divider sx={{ mb: 2 }} />
      <Skeleton variant="rounded" width="100%" height={120} />
    </Box>
  );

  return (
    <Box
      sx={{
        pt: 1,
        px: 1,
        mx: { xs: -1, md: -2 },
        height: "calc(100vh - 67px)",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#F8F8F8",
        position: "relative",
      }}
    >
      <Grid container spacing={1} sx={{ flex: 1, minHeight: 0 }}>
        {showPanels ? (
          <>
            <Grid item xs={12} md={3} sx={{ height: "100%" }}>
              <Paper
                elevation={2}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <Toolbar
                  sx={{
                    minHeight: "42px !important",
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    {isSearchActive ? (
                      <TextField
                        value={searchTerm}
                        onChange={handleSearchChange}
                        placeholder="Search Candidate name"
                        variant="outlined"
                        size="small"
                        style={{ flex: 1 }}
                      />
                    ) : (
                      <Typography variant="body1">Inactive candidates</Typography>
                    )}
                    {isSearchActive ? (
                      <CloseIcon
                        onClick={handleIconClick}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: "#696969",
                        }}
                      />
                    ) : (
                      <SearchIcon
                        onClick={handleIconClick}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          color: "#696969",
                        }}
                      />
                    )}

                    <Tooltip title="Move To Active">
                      <DriveFileMoveOutlinedIcon
                        style={{ color: "gray", cursor: selectedItems.length > 0 ? "pointer" : "not-allowed" }}
                        onClick={updateStatus}
                      />
                    </Tooltip>
                  </Box>
                </Toolbar>
                <Divider sx={{ margin: 0 }} />
                <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0 }}>
                  {loading ? (
                    <LoadingListSkeleton />
                  ) : (
                    <List sx={{ padding: 0 }}>
                      {/* {inActiveCandidates?.length > 0 && inActiveCandidates.map((candidate, index) => ( */}
                      {filteredCandidates.length > 0 &&
                        filteredCandidates.map((candidate, index) => (
                          <ListItemButton
                            key={candidate.candidate_id}
                            onClick={() => handleCandidateClick(candidate)}
                            onMouseOver={() => setHoverIndex(index)}
                            onMouseLeave={() => setHoverIndex(null)}
                            sx={{
                              ".more-icon": {
                                display: "none",
                              },
                              "&:hover": {
                                ".more-icon": {
                                  display: "block",
                                },
                              },
                              padding: isDesktopLarge ? "10px 20px" : "6px 12px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              backgroundColor:
                                selectedCandidate?.candidate_id === candidate.candidate_id
                                  ? "rgba(25, 118, 210, 0.08)"
                                  : "transparent",
                            }}
                          >
                            <Box sx={{ display: "flex", gap: 1, alignItems: "center", width: "100%", minWidth: 0 }}>
                              {hoverIndex === index ||
                                selectedItems.includes(candidate.candidate_id) ? (
                                <Checkbox
                                  checked={selectedItems.includes(
                                    candidate.candidate_id
                                  )}
                                  onChange={() =>
                                    handleListItemClick(index, candidate)
                                  }
                                  inputProps={{ "aria-label": "Checkbox demo" }}
                                  sx={{ flexShrink: 0, p: 0.5 }}
                                />
                              ) : (
                                <Avatar
                                  src={
                                    candidate?.image
                                      ? `${Key.aws_bucket_profile}/attachments/user_${candidate?.user_id}/profileimages/${candidate?.image}`
                                      : undefined
                                  }
                                  alt={candidate?.candidate_name || "N"}
                                  imgProps={{
                                    style: {
                                      objectFit: "cover",
                                    },
                                  }}
                                  sx={{
                                    flexShrink: 0,

                                    ...stringAvatar(candidate?.candidate_name || "N").sx,

                                    width: {
                                      xs: 30,
                                      sm: 32,
                                      md: 35,
                                      lg: 35,
                                    },

                                    height: {
                                      xs: 30,
                                      sm: 32,
                                      md: 35,
                                      lg: 35,
                                    },

                                    fontSize: {
                                      xs: "12px",
                                      sm: "13px",
                                      md: "14px",
                                      lg: "15px",
                                    },

                                    ...(candidate?.image && {
                                      bgcolor: "#fff",
                                    }),
                                  }}
                                >
                                  {!candidate?.image &&
                                    stringAvatar(candidate?.candidate_name || "N").children}
                                </Avatar>
                              )}
                              <Stack direction="column" sx={{ flex: 1, minWidth: 0 }}>
                                <Tooltip title={candidate.candidate_name} placement="top" arrow enterDelay={300}>
                                  <Typography
                                    component="span"
                                    noWrap
                                    sx={{
                                      display: "block",
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      margin: 0,
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {candidate.candidate_name}
                                  </Typography>
                                </Tooltip>
                                {candidate.role ? (
                                  <Tooltip title={candidate.role} placement="top" arrow enterDelay={300}>
                                    <Typography
                                      component="span"
                                      noWrap
                                      sx={{
                                        display: "block",
                                        fontSize: "12px",
                                        color: "gray",
                                        marginTop: "2px",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                      }}
                                    >
                                      {candidate.role}
                                    </Typography>
                                  </Tooltip>
                                ) : null}
                              </Stack>
                            </Box>
                          </ListItemButton>
                        ))}
                    </List>
                  )}
                </Box>
              </Paper>
            </Grid>

            <Grid item xs={12} md={9} sx={{ height: "100%" }}>
              <Paper
                elevation={2}
                sx={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: "8px",
                  overflow: "hidden",
                }}
              >
                <Toolbar
                  sx={{
                    minHeight: "42px !important",
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 500, margin: 0 }}
                    paragraph
                    id="tableTitle"
                    component="div"
                  >
                    Profile View
                  </Typography>
                </Toolbar>
                <Divider sx={{ margin: 0 }} />
                <Box sx={{ flex: 1, overflowY: "auto", minHeight: 0, p: 2 }}>
                  {loading ? (
                    renderProfileContentSkeleton()
                  ) : selectedCandidate ? (
                    <Box sx={{ padding: "10px" }}>
                      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                        {selectedCandidate.candidate_name || ""}
                      </Typography>
                      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2, flexWrap: "wrap", gap: 1 }}>
                        <Typography variant="subtitle1">
                          Role: {selectedCandidate.role || "—"}
                        </Typography>
                        <Typography variant="subtitle1">
                          Email: {selectedCandidate.email || "—"}
                        </Typography>
                      </Box>
                      <Divider sx={{ mb: 2 }} />

                      {selectedItems?.length > 0 ? (
                        <Box
                          sx={{
                            p: 2,
                            border: "1px solid lightgray",
                            borderRadius: "5px",
                            marginTop: "10px",
                          }}
                        >
                          <textarea
                            placeholder="Enter reason for moving to active..."
                            rows={5}
                            cols={30}
                            style={{ width: "100%", fontSize: "16px", height: "30%" }}
                            value={inactiveReason}
                            onChange={(e) => setInactiveReason(e.target.value)}
                          />
                          <Button variant="contained" onClick={updateStatus} sx={{ mt: 1 }}>
                            Save
                          </Button>
                        </Box>
                      ) : (
                        selectedCandidate?.inactive_reason && (
                          <Box
                            sx={{
                              p: 2,
                              border: "1px solid lightgray",
                              borderRadius: "5px",
                              marginTop: "10px",
                            }}
                          >
                            <Typography
                              variant="h6"
                              sx={{ fontWeight: "bold", color: "grey", mb: 1 }}
                            >
                              Reason for inactive
                            </Typography>
                            <Typography variant="subtitle1">
                              {selectedCandidate.inactive_reason}
                            </Typography>
                          </Box>
                        )
                      )}
                    </Box>
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%" }}>
                      <Typography variant="subtitle1" color="textSecondary">
                        Select a candidate to view details
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Paper>
            </Grid>
          </>
        ) : null}
      </Grid>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity="success"
          sx={{ width: "100%" }}
        >
          Candidates Moved to Active
        </Alert>
      </Snackbar>

      <Dialog
        open={inActiveCandidate}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="xs"
        disablePortal
        disableScrollLock
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 10,
          "& .MuiBackdrop-root": {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.4)",
          },
          "& .MuiDialog-container": {
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          "& .MuiDialog-paper": {
            width: "400px",
            margin: 0,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        {imageLoaded ? (
          <>
            <DialogTitle sx={{ textAlign: "center" }}>
              <img
                src={Noimag}
                alt="Placeholder"
                style={{
                  width: "100%",
                  objectFit: "contain",
                  borderRadius: "8px",
                  marginBottom: "8px",
                }}
              />
            </DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                No Inactive Candidate data was found based on the current search
                criteria.
              </Typography>
            </DialogContent>
          </>
        ) : (
          <DialogContent>
            <Typography variant="body1">Loading...</Typography>
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={handleCloseDialog}
            color="primary"
            variant="outlined"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Inactivecandidates;
